export default {
  SET_REGIONS(state, regions) {
    state.regions = regions
  },
  ADD_REGION(state, region) {
    state.regions.unshift(region)
  },
  UPDATE_REGION(state, region) {
    const index = state.regions.findIndex((t) => t.id === region.id)
    Object.assign(state.regions[index], region)
  },
  REMOVE_REGION(state, regionId) {
    const index = state.regions.findIndex((t) => t.id === regionId)
    state.regions.splice(index, 1)
  },
  SET_PROJECTS(state, projects) {
    state.projects = projects
  },
  ADD_PROJECT(state, project) {
    state.projects.unshift(project)
  },
  UPDATE_PROJECT(state, project) {
    const index = state.projects.findIndex((t) => t.id === project.id)
    Object.assign(state.projects[index], project)
  },
  REMOVE_PROJECT(state, projectId) {
    const index = state.projects.findIndex((t) => t.id === projectId)
    state.projects.splice(index, 1)
  },
  SET_HYPERION_LOMS(state, hyperionLoms) {
    state.hyperionLoms = hyperionLoms
  },
  SET_PROJECT_LOMS(state, projectLoms) {
    state.projectLoms = projectLoms
  },
  ADD_PROJECT_LOM(state, projectLom) {
    state.projectLoms.unshift(projectLom)
  },
  UPDATE_PROJECT_LOM(state, projectLom) {
    const index = state.projectLoms.findIndex((t) => t.id === projectLom.id)
    Object.assign(state.projectLoms[index], projectLom)
  },
  REMOVE_PROJECT_LOM(state, projectLomId) {
    const index = state.projectLoms.findIndex((t) => t.id === projectLomId)
    state.projectLoms.splice(index, 1)
  },
  SET_CORPORATE_LOMS(state, corporateLoms) {
    state.corporateLoms = corporateLoms
  },
  ADD_CORPORATE_LOM(state, corporateLom) {
    state.corporateLoms.unshift(corporateLom)
  },
  UPDATE_CORPORATE_LOM(state, corporateLom) {
    const index = state.corporateLoms.findIndex((t) => t.id === corporateLom.id)
    Object.assign(state.corporateLoms[index], corporateLom)
  },
  REMOVE_CORPORATE_LOM(state, corporateLomId) {
    const index = state.corporateLoms.findIndex((t) => t.id === corporateLomId)
    state.corporateLoms.splice(index, 1)
  },
  SET_COMPILATIONS(state, compilations) {
    state.compilations = compilations
  },
  ADD_COMPILATION(state, compilation) {
    state.compilations.unshift(compilation)
  },
  UPDATE_COMPILATION(state, compilation) {
    const index = state.compilations.findIndex((t) => t.id === compilation.id)
    Object.assign(state.compilations[index], compilation)
  },
  REMOVE_COMPILATION(state, compilationId) {
    const index = state.compilations.findIndex((t) => t.id === compilationId)
    state.compilations.splice(index, 1)
  },
  DUPLICATE_COMPILATION(state, compilation) {
    state.compilations.unshift(compilation);
  },
  SET_HYPERION_ENTITIES(state, hyperionEntity) {
    state.hyperionEntities = hyperionEntity
  },
  SET_YEARLY_FX_RATE_TEMPLATES(state, templates) {
    state.yearlyFxRateTemplates = templates
  },
  SET_YEARLY_INFLATION_RATE_TEMPLATES(state, templates) {
    state.yearlyInflationRateTemplates = templates
  },
  SET_ELEMENT_YEARLY_PRICE_TEMPLATES(state, templates) {
    state.elementYearlyPriceTemplates = templates
  }
}
